import { useEffect, useState } from "react";
import { Card, Typography, Button, Box, CircularProgress, Tooltip, RadioGroup, Radio, Textarea, IconButton, Select, Option, Switch } from "@mui/joy";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import { Stack } from "@mui/material";
import Blub from '../img/bulb.png';
import Data from '../img/data.png';
import { Face, Face2, Key } from "@mui/icons-material";
import { useLanguage } from "../LanguageProvider";
import { createInvoice } from "../components/CreateInvoice";
import { redirect, useNavigate } from "react-router-dom";

const isRussianDomain = window.location.hostname === 'chat.acceptancegroup.org';

function Settings({ temperature, onChangeTemperature, instructions, onSetInstructions, faceSet, isMobile, voice, setVoice }) {
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    const { changeLanguage, currentLanguageData, language } = useLanguage();

    const handleChangeLang = (event, newValue) => {
        changeLanguage(newValue);
    };

    const handleChangeVoice = (event, newValue) => {
        setVoice(newValue);
    };

    const [checkedSound, setCheckedSound] = useState(() => {
        const storedValue = localStorage.getItem('sounds');
        return storedValue ? JSON.parse(storedValue) : true;
    });

    const [checkedNotify, setCheckedNotify] = useState(() => {
        const storedValue = localStorage.getItem('notify');
        return storedValue ? JSON.parse(storedValue) : true;
    });

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: ((window.__TAURI_INTERNALS__ && !isMobile) ? 'calc(100vh - 30px)' : '100vh') }}>
                <CircularProgress color='neutral' />
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
            <Stack sx={{
                width: '90%',
                marginTop: '90px',
                maxWidth: '740px',
            }}>

                <Card color="warning" variant="soft" sx={{ mb: 2, borderRadius: 20, overflow: 'hidden' }}>
                    <Typography level="title-md">{currentLanguageData.advancedDesc}</Typography>
                    <Typography level="body-sm" sx={{ mt: -0.5 }}>
                        <span dangerouslySetInnerHTML={{ __html: currentLanguageData.smartFullText }} />
                    </Typography>
                    <Button onClick={() => navigate('/plans')} color="warning" sx={{ width: 'auto', alignSelf: 'flex-start', borderRadius: 30 }} variant="solid">{currentLanguageData.getStarted}</Button>
                    <img style={{ pointerEvents: 'none', opacity: 0.3, position: 'absolute', right: 10, bottom: -40, height: '110%', objectFit: 'cover' }} src={Blub} />
                </Card>

                <Card color="primary" variant="soft" sx={{ mb: 2, borderRadius: 20, overflow: 'hidden' }}>
                    <Typography level="title-md">Developer Program</Typography>
                    <Typography level="body-sm" sx={{ mt: -0.5 }}>
                        <span dangerouslySetInnerHTML={{ __html: currentLanguageData.devprog }} />
                    </Typography>
                    <Stack direction="row" spacing={1}>
                        <Button onClick={() => window.open('https://docs.screwltd.com/api/ai/capricorn', '_blank')} color="primary" sx={{ width: 'auto', alignSelf: 'flex-start', borderRadius: 30 }} variant="solid">{currentLanguageData.docs}</Button>
                        <IconButton onClick={() => window.open(isRussianDomain ? `https://account.acceptancegroup.org/api?token=${user.jwt_token}` : `https://account.screwltd.com/api?token=${user.jwt_token}`, '_blank')} color="primary" sx={{ width: 'auto', alignSelf: 'flex-start', borderRadius: 30 }} variant="solid"><Key sx={{ transform: 'rotate(135deg)' }} /></IconButton>
                    </Stack>
                    <img style={{ pointerEvents: 'none', opacity: 0.3, position: 'absolute', right: -40, bottom: -60, height: '170%', objectFit: 'cover' }} src={Data} />
                </Card>
                {window.__TAURI_INTERNALS__ && (
                    <Card variant="soft" sx={{ mb: 2, borderRadius: 20 }}>
                        <Typography level="title-md">{currentLanguageData.app}</Typography>

                        <Stack spacing={1}>
                            <Card variant="plain" sx={{ borderRadius: 250, py: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography>{currentLanguageData.msgSound}</Typography>
                                    <Switch checked={checkedSound}
                                        onChange={(event) => {
                                            const newValue = event.target.checked;
                                            setCheckedSound(newValue);
                                            localStorage.setItem('sounds', JSON.stringify(newValue));
                                            console.log(localStorage.getItem('sounds'));
                                        }} />
                                </Box>
                            </Card>
                            <Card variant="plain" sx={{ borderRadius: 250, py: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography>{currentLanguageData.notifyShow}</Typography>
                                    <Switch checked={checkedNotify}
                                        onChange={(event) => {
                                            const newValue = event.target.checked;
                                            setCheckedNotify(newValue);
                                            localStorage.setItem('notify', JSON.stringify(newValue));
                                            console.log(localStorage.getItem('notify'));
                                        }} />
                                </Box>
                            </Card>
                        </Stack>
                        <Typography level='body-xs' sx={{ width: '100%' }}>{currentLanguageData.appSettingsDesc}</Typography>
                    </Card>
                )}
                <Card variant="soft" sx={{ mb: 2, borderRadius: 20 }}>
                    <Typography level="title-md">{currentLanguageData.lang}</Typography>
                    <Select variant="plain" defaultValue={language} onChange={handleChangeLang} sx={{ borderRadius: 20, borderColor: 'transparent', '&:hover': { bgcolor: 'background.surface' }, }}>
                        <Option value="en">English</Option>
                        <Option value="ru">Русский</Option>
                        <Option value="pl">Polski</Option>
                        <Option value="zh">中国人</Option>
                    </Select>
                    <Typography level='body-xs' sx={{ width: '100%' }}>{currentLanguageData.langDesc}</Typography>
                </Card>
                <Card variant="soft" sx={{ mb: 2, borderRadius: 20 }}>
                    <Typography level="title-md">{currentLanguageData.creativity}</Typography>
                    <RadioGroup
                        orientation="horizontal"
                        aria-labelledby="segmented-controls-example"
                        value={temperature}
                        onChange={(event) => onChangeTemperature(event.target.value)}
                        sx={{
                            minHeight: 48,
                            padding: 0,
                            width: '100%',
                            borderRadius: '25px',
                            overflow: 'hidden',
                            boxShadow: '0 0 0 2px rgba(0, 0, 0, 0.25)',
                            bgcolor: 'neutral.softBg',
                            '--RadioGroup-gap': '4px',
                            '--Radio-actionRadius': '8px',
                        }}
                    >
                        <Radio
                            color="neutral"
                            value='0.1'
                            disableIcon
                            label={currentLanguageData.creativityAccurate}
                            variant="plain"
                            sx={{
                                px: 2,
                                fontSize: isMobile ? 11 : 16,
                                alignItems: 'center',
                                width: '100%',
                                textAlign: 'center',
                            }}
                            slotProps={{
                                action: ({ checked }) => ({
                                    sx: {
                                        borderRadius: 25,
                                        '&:hover': {
                                            bgcolor: 'rgba(0,0,0,0.3)',
                                        },
                                        ...(checked && {
                                            bgcolor: 'background.surface',
                                            boxShadow: 'sm',
                                            '&:hover': {
                                                bgcolor: 'background.surface',
                                            },
                                        }),
                                    },
                                }),
                            }}
                        />
                        <Radio
                            color="neutral"
                            value='0.7'
                            disableIcon
                            label={currentLanguageData.creativityBalanced}
                            variant="plain"
                            sx={{
                                px: 2,
                                fontSize: isMobile ? 11 : 16,
                                alignItems: 'center',
                                width: '100%',
                                textAlign: 'center'
                            }}
                            slotProps={{
                                action: ({ checked }) => ({
                                    sx: {
                                        borderRadius: 25,
                                        '&:hover': {
                                            bgcolor: 'rgba(0,0,0,0.3)',
                                        },
                                        ...(checked && {
                                            bgcolor: 'background.surface',
                                            boxShadow: 'sm',
                                            '&:hover': {
                                                bgcolor: 'background.surface',
                                            },
                                        }),
                                    },
                                }),
                            }}
                        />
                        <Radio
                            color="neutral"
                            value='1.6'
                            disableIcon
                            label={currentLanguageData.creativityCreative}
                            variant="plain"
                            sx={{
                                px: 2,
                                fontSize: isMobile ? 11 : 16,
                                alignItems: 'center',
                                width: '100%',
                                textAlign: 'center'
                            }}
                            slotProps={{
                                action: ({ checked }) => ({
                                    sx: {
                                        borderRadius: 25,
                                        '&:hover': {
                                            bgcolor: 'rgba(0,0,0,0.3)',
                                        },
                                        ...(checked && {
                                            bgcolor: 'background.surface',
                                            boxShadow: 'sm',
                                            '&:hover': {
                                                bgcolor: 'background.surface',
                                            },
                                        }),
                                    },
                                }),
                            }}
                        />
                    </RadioGroup>
                    <Typography level='body-xs' sx={{ width: '100%' }}><span dangerouslySetInnerHTML={{ __html: currentLanguageData.creativityDesc }} /></Typography>
                </Card>
                <Card variant="soft" sx={{ mb: 2, borderRadius: 20 }}>
                    <Typography level="title-md">{currentLanguageData.voiceBtn}</Typography>
                    <Select defaultValue={voice} onChange={handleChangeVoice} variant="plain" sx={{ borderRadius: 20, borderColor: 'transparent', '&:hover': { bgcolor: 'background.surface' }, }}>
                        <Option key="alloy" value="alloy">Alloy</Option>
                        <Option key="amuch" value="amuch">Amuch</Option>
                        <Option key="ash" value="ash">Ash</Option>
                        <Option key="aster" value="aster">Aster</Option>
                        <Option key="ballad" value="ballad">Ballad</Option>
                        <Option key="brook" value="brook">Brook</Option>
                        <Option key="clover" value="clover">Clover</Option>
                        <Option key="coral" value="coral">Coral</Option>
                        <Option key="dan" value="dan">Dan</Option>
                        <Option key="echo" value="echo">Echo</Option>
                        <Option key="elan" value="elan">Elan</Option>
                        <Option key="fable" value="fable">Fable</Option>
                        <Option key="marilyn" value="marilyn">Marilyn</Option>
                        <Option key="meadow" value="meadow">Meadow</Option>
                        <Option key="nova" value="nova">Nova</Option>
                        <Option key="onyx" value="onyx">Onyx</Option>
                        <Option key="sage" value="sage">Sage</Option>
                        <Option key="shimmer" value="shimmer">Shimmer</Option>
                        <Option key="verse" value="verse">Verse</Option>
                    </Select>
                    <Typography level='body-xs' sx={{ width: '100%' }}>{currentLanguageData.voiceDesc}</Typography>
                </Card>
                <Card variant="soft" sx={{ mb: 2, borderRadius: 20 }}>
                    <Typography level="title-md">{currentLanguageData.sysinst}</Typography>
                    <Textarea
                        sx={{
                            fontSize: 14,
                            borderRadius: 20,
                            borderColor: 'rgba(0, 0, 0, 0.25)',
                            '&::before, &::after': { background: 'transparent', filter: null },
                            'textarea': { marginRight: 0, marginLeft: 0, marginTop: 0.1, marginBottom: 0, scrollbarWidth: 'none' }
                        }}
                        value={instructions}
                        onChange={(e) => onSetInstructions(e.target.value)}
                        placeholder={currentLanguageData.systinstLabel}
                    />
                    <Typography level='body-xs' sx={{ width: '100%' }}><span dangerouslySetInnerHTML={{ __html: currentLanguageData.sysinstDesc }} /></Typography>
                </Card>
                <Card variant="soft" sx={{ mb: 2, borderRadius: 20 }}>
                    <Typography level="title-md">{currentLanguageData.intmem}</Typography>
                    {!user?.ai?.memory || user.ai.memory.length === 0 ? (
                        <Typography level="body-sm" sx={{ mt: -0.5 }}>{currentLanguageData.intmemNan}</Typography>
                    ) : (
                        user.ai.memory.map((item, index) => (
                            <Card variant="plain" sx={{ borderRadius: 25 }} key={index}>
                                <Typography level="body-sm">{item}</Typography>
                            </Card>
                        ))
                    )}
                    <Typography level='body-xs' sx={{ width: '100%' }}><span dangerouslySetInnerHTML={{ __html: currentLanguageData.intmemDesc }} /></Typography>
                </Card>
                {/*
                <Card color="danger" sx={{ mb: 2 }}>
                    <Typography level="title-md">{currentLanguageData.testTitle}</Typography>
                    <Button onClick={() => faceSet(true)} color="danger" startDecorator={<Face />} sx={{ width: 'auto', alignSelf: 'flex-start', borderRadius: 30 }} variant="soft">{currentLanguageData.faceBtn}</Button>
                    <Typography level='body-xs' sx={{ width: '100%' }}>{currentLanguageData.testDanger}</Typography>
                </Card>
                */}
            </Stack>
        </div >
    );
}

export default Settings;
